import PendingSvg from "../../components/icons/SuccessKycSvg";
import { CustomButton } from "../dashboard/components";

export default function KycPendingViaRain() {
  return (
    <div className="flex flex-col">
      <div className="rounded-[4px] bg-black flex flex-col items-center justify-center">
        <PendingSvg />
      </div>
      <div className="rounded-b-md flex flex-col gap-1 overflow-clip">
        <div className="bg-[#18181C] p-[12px]">
          <p className="text-[#E6E8ED] text-center font-['Neue Montreal'] text-[16px] font-medium leading-[120%]">
            Your User Verification has been successfully submitted. You can
            close this window and return to the dashboard. Once the User
            Verification is approved, you'll be able to start using your card.
          </p>
        </div>
        <div className="bg-[#18181C] p-[12px]">
          <CustomButton className="w-full">Dashboard</CustomButton>
        </div>
      </div>
    </div>
  );
}
